import React, { useEffect, useState } from "react";
import { AppBar, Typography, Toolbar, Button, Avatar } from "@material-ui/core";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import decode from "jwt-decode";
import useStyles from "./styles";
import memoriesLogo from "../../images/memoriesLogo.png";
import memoriesText from "../../images/memoriesText.png";

const Navbar = () => {
    const classes = useStyles();
    const [user, setUser] = useState(
        JSON.parse(localStorage.getItem("profile"))
    );
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const logout = () => {
        dispatch({ type: "LOGOUT" });

        navigate(0);
        setUser(null);
    };

    useEffect(() => {
        const token = user?.token;

        if (token) {
            const decodedToken = decode(token);

            if (decodedToken.exp * 1000 < new Date().getTime()) logout();
        }

        setUser(JSON.parse(localStorage.getItem("profile")));
    }, [location]);

    return (
        <AppBar className={classes.appBar} position="static" color="inherit">
            <Link to="/" className={classes.brandContainer}>
                <img src={memoriesText} alt="icon" height="45px" />
                <img
                    className={classes.image}
                    src={memoriesLogo}
                    alt="icon"
                    height="40px"
                />
            </Link>
            <Toolbar className={classes.toolbar}>
                {user ? (
                    <Link
                        to={`/creators/${user.result.name}`}
                        style={{
                            textDecoration: "none",
                            color: "black",
                        }}
                    >
                        <div className={classes.profile}>
                            <Avatar
                                className={classes.purple}
                                alt={user.result.name}
                                src={user.result.imageUrl}
                            >
                                {user.result.name.charAt(0)}
                            </Avatar>
                            <Typography
                                className={classes.userName}
                                variant="h6"
                            >
                                {user.result.name}
                            </Typography>

                            <Button
                                variant="contained"
                                className={classes.logout}
                                color="secondary"
                                onClick={logout}
                            >
                                Logout
                            </Button>
                        </div>
                    </Link>
                ) : (
                    <Button
                        component={Link}
                        to="/auth"
                        variant="contained"
                        color="primary"
                    >
                        Sign in
                    </Button>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;
